import { useTranslate } from '@ur-solutions/react-hooks'
import { Checkbox } from '@/components_deprecated'
import type { FilterChildren } from '@/components_deprecated/FilterPopup'
import { FilterPopup } from '@/components_deprecated/FilterPopup'
import { StyledScrollBar } from '@/components_deprecated/FilterPopup/components'
import xor from 'lodash/xor'
import type { VehicleExpirationFilterType } from '@/modules/vehicles/types'
import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import type {
  VehicleExpirationTypesQuery,
  VehicleExpirationTypesQueryVariables,
} from '@/modules/vehicles/types.graphql'
import { ALL_VEHICLE_EXPIRATION_TYPES_SHALLOW_QUERY } from '@/modules/vehicles/queries'
import { getVehicleExpirationTypeName } from '../../util'
import { H4 } from '@/components'

interface VehicleExpirationTypeFilterProps
  extends FilterChildren<VehicleExpirationFilterType> {}

export const VehicleExpirationFilter: React.FC<
  VehicleExpirationTypeFilterProps
> = ({ filter, onUpdate }) => {
  const translations = useTranslate({
    type: 'common.type',
  })

  const { data, loading } = useQuery<
    VehicleExpirationTypesQuery,
    VehicleExpirationTypesQueryVariables
  >(ALL_VEHICLE_EXPIRATION_TYPES_SHALLOW_QUERY, {
    variables: { orderBy: 'name' },
  })

  const categories = useMemo(
    () => data?.allVehicleExpirationTypes.edges.map(({ node }) => node) ?? [],
    [data]
  )

  function toggleCategory(categoryId: string) {
    return () => {
      const newSelected = xor(filter.expirationTypes ?? [], [categoryId])
      onUpdate({ expirationTypes: newSelected })
    }
  }

  return (
    <FilterPopup>
      <H4>{translations.type}</H4>
      <StyledScrollBar>
        {loading && <div>Loading...</div>}
        {categories.map(category => {
          const checked = filter.expirationTypes?.includes(category.id) ?? false
          return (
            <Checkbox
              key={category.id}
              checked={checked}
              label={getVehicleExpirationTypeName({ name: category.name })}
              boxWidth="32px"
              boxHeight="32px"
              fontSize="1rem"
              onChange={toggleCategory(category.id)}
            />
          )
        })}
      </StyledScrollBar>
    </FilterPopup>
  )
}
